<template>
  <div class="bg">
    <div style="display: flex; width: 500px; margin-bottom: 30px">
      <el-input style="width: 200px" v-model="winner" clearable placeholder="控制转到哪个奖品"></el-input>
      <div style="display: flex; align-items: center">
        <div style="width: 8em">是否指定结果：</div>
        <el-select v-model="specified" placeholder="是否随机">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </div>
    </div>
    <div class="overall">
      <div class="zp-box">
        <div class="panzi">
          <div class="bck-box" :style="` transform: rotate(${-90 + 180 / list.length}deg)`">
            <div class="bck" v-for="(i, index) in list" :key="index" :style="`transform: rotate(${(-index * 360) / list.length}deg) skew(${-90 + 360 / list.length}deg);`"></div>
          </div>
          <div class="jiang" :style="`transform: rotate(${(-index * 360) / list.length}deg) translateY(-10vw);`" v-for="(i, index) in list" :key="index">
            <div class="title">{{ i.title }}</div>
            <img style="width: 80%; margin-top: 5%" src="@/assets/lottery.png" alt="" />
          </div>
        </div>
        <div class="start-btn" @click="start()">抽奖</div>
      </div>
    </div>
    <div style="padding-top: 40px; color: #000">您还剩1次机会</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      winner: 2, //指定获奖下标 specified为true时生效
      specified: true, //是否指定获奖结果，false时为随机
      loading: false, //抽奖执行状态，防止用户多次点击
      panziElement: null,
      list: [
        {
          title: '特等奖'
        },
        {
          title: '一等奖'
        },
        {
          title: '二等奖'
        },
        {
          title: '三等奖'
        },
        {
          title: '四等奖'
        },
        {
          title: '五等奖'
        },
        {
          title: '六等奖'
        },
        {
          title: '七等奖'
        }
        // {
        //   title: '八等奖'
        // },
        // {
        //   title: '九等奖'
        // }
      ],
      options: [
        {
          value: true,
          label: '是'
        },
        {
          value: false,
          label: '否'
        }
      ]
    }
  },
  computed: {
    animationClass() {
      switch (this.winner) {
        case 0:
        case '0':
          return 'wr0'
        case 1:
        case '1':
          return 'wr1'
        case 2:
        case '2':
          return 'wr2'
        case 3:
        case '3':
          return 'wr3'
        case 4:
        case '4':
          return 'wr4'
        case 5:
        case '5':
          return 'wr5'
        case 6:
        case '6':
          return 'wr6'
        case 7:
        case '7':
          return 'wr7'
        default:
          return 'wr0' // 默认返回一个值
      }
    }
  },
  mounted() {
    let root = document.querySelector(':root')
    root.style.setProperty('--nums', this.list.length)
  },
  methods: {
    //开始抽奖
    start() {
      if (!this.loading) {
        this.panziElement = document.querySelector('.panzi')
        this.panziElement.classList.remove(this.animationClass)
        if (this.specified) {
          //此处可指定后端返回的指定奖品
          // this.winner = 1
          this.winCallback()
        } else {
          this.winner = this.random(0, this.list.length - 1)
          this.winCallback()
        }
        this.loading = true
      }
    },
    //中奖返回方法
    winCallback() {
      setTimeout(() => {
        /* 此处是为了解决当下次抽中的奖励与这次相同，动画不重新执行的 */
        /* 添加一个定时器，是为了解决动画属性的替换效果，实现动画的重新执行 */
        this.panziElement.classList.add(this.animationClass)
      }, 0)
      // 因为动画时间为 3s ，所以这里3s后获取结果，其实结果早就定下了，只是何时显示，告诉用户
      setTimeout(() => {
        this.loading = false
        console.log(`恭喜你获得了${this.winner}`)
      }, 3000)
    },
    //随机一个整数的方法
    random(min, max) {
      return parseInt(Math.random() * (max - min + 1) + min)
    }
  }
}
</script>
<style lang="scss" scoped>
// $zp_size: 23rem; //转盘尺寸
// $btn_size: 7rem; //抽奖按钮尺寸
// $time: 3s; //转动多少秒后停下的时间
$zp_size: 30vw; // 转盘尺寸为视口宽度的50%
$btn_size: 10vw; // 按钮尺寸为视口宽度的10%
$time: 3s; // 转动时间

::v-deep(.van-icon) {
  position: fixed;
  top: 0;
  left: 0;
  padding: 20px 10px;
}

.bg {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  // background-image: url('../assets/R.jfif');
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.overall {
  display: flex;
  justify-content: center;
  align-items: center;
  // width: 100%;
}

.zp-box {
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: $zp_size;
  height: $zp_size;

  /* 抽奖按钮 */
  .start-btn {
    display: inline-block;
    background: #f53737;
    position: relative;
    z-index: 2;
    cursor: pointer;
    width: $btn_size;
    height: $btn_size;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    // font-size:2rem;
    font-size: 16px;
    font-weight: bold;
    box-sizing: border-box;
    position: relative;
    z-index: 2;

    &::before {
      content: '';
      width: 0;
      height: 0;
      border: 2rem solid transparent;
      border-top: 3rem solid transparent;
      border-bottom: 3rem solid #f53737;
      position: absolute;
      top: -5rem;
      z-index: -1;
    }
  }

  /* 转盘缓慢旋转 */
  @keyframes slowRotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  /* 快速旋转动画 */
  @keyframes fastRotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(calc(360deg * 5 + 360deg / var(--nums) * var(--winner)));
      /* 5圈 + 偏移量 */
    }
  }

  /* 盘子样式 */
  .panzi {
    animation: slowRotate 20s linear infinite;
    /* 慢速旋转动画，20秒完成一圈 */
    overflow: hidden;
    border-radius: 50%;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 10px solid #f9bd76;
    box-sizing: border-box;

    /* 每个奖项的样式 */
    .jiang {
      position: absolute;
      width: 14.5%;
      height: 20%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .title {
        // font-weight: bold;
        font-size: 12px;
        color: #3b3b3b;
        word-wrap: break-word;
        /* 自动换行 */
        word-break: break-word;
        /* 强制在单词边界内换行 */
        white-space: normal;
        /* 允许正常换行 */
        max-width: 80%;
        /* 可根据需要调整最大宽度 */
      }

      .img {
        margin: 0.5rem auto;
        width: 2.5rem;
        height: 2.5rem;
        line-height: 2.5rem;
        border: 2px dashed #f87373;
        overflow: hidden;
        color: white;

        img {
          height: 100%;
        }
      }
    }
  }

  .bck-box {
    overflow: hidden;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    // background: blue;
    border-radius: 50%;

    /* 转盘扇形背景 */
    .bck {
      box-sizing: border-box;
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 1;
      top: -50%;
      left: 50%;
      transform-origin: 0% 100%;
      border: 2px dashed #c19a7d;
      border-left-color: transparent;
      // transform:skew(30deg);
    }

    /* 转盘背景色 */
    .bck:nth-child(2n) {
      background: #fffbf4;
    }

    .bck:nth-child(2n + 1) {
      background: #ffeee2;
      box-shadow: 0 0 5px #f9bd76;
    }
  }

  /* 下面的css样式为每个奖品的旋转动画，这里写了对应8个奖品的动画，如果想要更多的话，可以添加 */
  /* 例如： .wr8  @keyframes play8 */
  .wr0,
  .wr1,
  .wr2,
  .wr3,
  .wr4,
  .wr5,
  .wr6,
  .wr7 {
    animation-duration: $time;
    animation-timing-function: ease;
    animation-fill-mode: both;
    animation-iteration-count: 1;
  }

  .wr0 {
    animation-name: play0;
  }

  .wr1 {
    animation-name: play1;
  }

  .wr2 {
    animation-name: play2;
  }

  .wr3 {
    animation-name: play3;
  }

  .wr4 {
    animation-name: play4;
  }

  .wr5 {
    animation-name: play5;
  }

  .wr6 {
    animation-name: play6;
  }

  .wr7 {
    animation-name: play7;
  }

  @keyframes play0 {
    to {
      transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 0));
    }
  }

  @keyframes play1 {
    to {
      transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 1));
    }
  }

  @keyframes play2 {
    to {
      transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 2));
    }
  }

  @keyframes play3 {
    to {
      transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 3));
    }
  }

  @keyframes play4 {
    to {
      transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 4));
    }
  }

  @keyframes play5 {
    to {
      transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 5));
    }
  }

  @keyframes play6 {
    to {
      transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 6));
    }
  }

  @keyframes play7 {
    to {
      transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 7));
    }
  }
}

/* 媒体查询 */
@media (max-width: 768px) {
  $zp_size: 70vw; // 移动端转盘尺寸调整为视口的70%
  $btn_size: 15vw; // 移动端按钮尺寸调整为视口的15%

  .start-btn {
    font-size: 20px; // 小屏幕时按钮字体小一些
  }
}
</style>
